/* eslint-disable import/prefer-default-export */
import { takeLatest, put } from 'redux-saga/effects'
import getRegionalProjectIdAction, {
    getRegionalProjectIdTypes,
} from '../../../../redux/donneesSocioEconomique/donneesRegionalProject/getRegionalProjectId'
import { Get } from '../../../../serveur/axios'

function* getRegionalProjectIdSagas({ response }) {
    try {
        const res = yield Get(`regional-project/${response.id}`)
        if (res.status === 200) {
            yield put(
                getRegionalProjectIdAction.getRegionalProjectIdSuccess(
                    res.data.data
                )
            )
        } else {
            yield put(
                getRegionalProjectIdAction.getRegionalProjectIdFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(getRegionalProjectIdAction.getRegionalProjectIdFailure(error))
    }
}

export function* getRegionalProjectIdSaga() {
    yield takeLatest(
        getRegionalProjectIdTypes.GET_REGIONAL_PROJECT_ID_REQUEST,
        getRegionalProjectIdSagas
    )
}
